module.exports = __webpack_public_path__ + "img/penjaminan-aman-asippindo.55cb21de.jpg";